import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { loader, p } from "~/misc/common";

export default class extends Controller {
  connect() {
    console.log('initTransactionsBatch');

    let ids: string[] = [];
    //var sp_sum = 0;
    let all = false;

    $('input.batch-select').on('change', function () {
      refresh();
    });

    $('#selectAll').on('click', function () {
      all = !all;
      $('input.batch-select:not(:disabled)').each(function () {
        (this as HTMLInputElement).checked = all;
      });
      refresh();
    });

    function refresh() {
      ids = [];
      //sp_sum = 0;
      $('input.batch-select').each(function () {
        const id = this.id.replace('item_', '');
        if ((this as HTMLInputElement).checked) {
          ids.push(id);
          //sp_sum += $(this).data('sp');
        }
      });
      $('span.batch-count').text(ids.length);
      //$('span.batch-sp').text(sp_sum);
      if (ids.length > 0) {
        $('.batch-actions').show(0);
      } else {
        $('.batch-actions').hide(0);
      }
      //p(ids);
    }

    function submit(data: any) {
      loader(true);
      $.ajax({
        url: '/transactions/batch.json',
        type: 'PUT',
        data: data,
        success: function (result) {
          console.log(result);
          if (result.success) {
            location.reload();
          } else {
            loader(false);
            alert('Hiba: ' + result.error);
          }
        }
      });
    }

    $('form.new_transaction').on('submit', function () {
      $('#modalUser').modal('hide');
      const data: any = $(this).serializeArray().reduce(function (m: any, o) {
        m[o.name] = o.value;
        return m;
      }, {});
      data.ids = ids;
      submit(data);
      return false;
    });
  }
}